@if (showButton) {
  <ng-container *ngTemplateOutlet="buttonTemplate" />
}

@if (showLink) {
  <ng-container *ngTemplateOutlet="linkTemplate" />
}

<ng-template #buttonTemplate>
  <button
    class="ag1-link flex items-center justify-center gap-1"
    [class]="'ag1-link--' + variant + ' ' + (classOverrides || '')"
    [class.flex-row]="position !== 'right'"
    [class.flex-row-reverse]="position === 'right'"
    [class.ag1-link--active]="isActive"
    [ag1Tooltip]="tooltip"
    [tooltipPosition]="tooltipPosition"
    [tooltipTemplateRef]="tooltipTemplateRef"
    [tooltipHasArrow]="tooltipHasArrow"
    [tooltipVariant]="variant"
    [disabled]="disabled"
    (click)="onClick($event)"
  >
    <ng-container *ngTemplateOutlet="projectedContentTemplate" />
    @if (label) {
      <span>
        @if (!formatWithSentenceCase) {
          {{ label }}
        }
        @if (formatWithSentenceCase) {
          {{ label | sentenceCase }}
        }
      </span>
    }
  </button>
</ng-template>

<ng-template #linkTemplate>
  <a
    class="ag1-link flex items-center justify-center gap-1"
    [class]="'ag1-link--' + variant + ' ' + (classOverrides || '')"
    [class.flex-row]="position !== 'right'"
    [class.flex-row-reverse]="position === 'right'"
    [class.ag1-link--active]="isActive"
    [ag1Tooltip]="tooltip"
    [tooltipPosition]="tooltipPosition"
    [tooltipTemplateRef]="tooltipTemplateRef"
    [tooltipHasArrow]="tooltipHasArrow"
    [tooltipVariant]="variant"
    [routerLink]="routerLink"
    [queryParams]="queryParams"
  >
    <ng-container *ngTemplateOutlet="projectedContentTemplate" />
    @if (label) {
      <span>
        @if (!formatWithSentenceCase) {
          {{ label }}
        }
        @if (formatWithSentenceCase) {
          {{ label | sentenceCase }}
        }
      </span>
    }
  </a>
</ng-template>

<!-- DEVELOPER NOTE:
This component renders either a button or link.
The use of the projected template is to allow projected content to be passed into the rendered html element. Angular has a restriction that prevents ng-content from being rendered more than once. By placing it within a template we can control which html element receives the projected content. Please consider before removal. This was done to prevent having to set ng-content slots for backwards compatibility.
-->
<ng-template #projectedContentTemplate>
  <ng-content />
</ng-template>
